import { studentTypeToCollectionType } from '@/helpers/collectionTypes';
import type { OrganizationUpdateDTODiscountCodes } from '@/api/trafikportalen';
import type { StudentType } from '@/types/students';

export const hasHalfProductDiscountCode = (
  discountCodes: OrganizationUpdateDTODiscountCodes | undefined,
  studentType: StudentType,
): boolean => {
  const collectionType = studentTypeToCollectionType(studentType);
  const code = discountCodes?.[collectionType]?.half_product?.trim();
  return Boolean(code);
};
